<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="chapter" title="NOTE ON MAPS">
<h2 class="h2b"><a id="page_xiii"></a><a id="frontmatter02"></a>NOTE ON MAPS</h2>
<p class="para">A number of the maps used in this work were rough sketches drawn by soldiers as they recounted their experiences during the Korean War. As such, the maps employ a variety of symbols for terrain and military operations. To ensure clarity, notations have been added to some sketches. Whenever possible, the standard military and topographical symbols shown below have been used, along with common abbreviations. Numbers on all contours are in meters.</p>
<p class="image"><img alt="Image" src="images/f0xiii-01.jpg"/></p>
<p class="image"><a id="page_xiv"></a><img alt="Image" src="images/f0xiv-01.jpg"/></p>
<p class="para">The following symbols placed in boundary lines or position area ovals or above the rectangle, triangle, or circle enclosing the identifying arm or service symbol indicate the size of military organizations.</p>
<p class="image"><img alt="Image" src="images/f0xiv-02.jpg"/></p>
<p class="para"><a id="page_xv"></a>Examples are given below. The letter or number to the left of the symbol indicates the unit designation; that to the right, the designation of the parent unit to which it belongs. Letters or numbers above or below boundary lines designate the units separated by the lines. Unit designations sometimes are shown as 3/A/9 (3d Platoon, Company A, 9th Infantry Regiment) or as 1–9 (1st Battalion, 9th Infantry Regiment).</p>
<p class="image"><img alt="Image" src="images/f00xv-01.jpg"/></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// frontmatter02.vue?a7668900